<div>
  <div #threeContainer></div>
  <video #videoElement autoplay muted></video>
  <canvas #canvasElement></canvas>
</div>
